export default "/_next/static/fonts/c63fa49a8f37b56cb93d9b88958b1fb3.ttf";